import { useState } from 'react'
import { toast } from 'react-hot-toast'
import { suggestAnimeEdit } from '../../services/AnimeDB/animeDB.service.remote'

export function AnimeEditSuggestionForm({ anime, onClose }) {
  const [fields, setFields] = useState({
    title_hebrew: anime.title_hebrew || '',
    synopsis_hebrew: anime.synopsis_hebrew || '',
    background_hebrew: anime.background_hebrew || '',
  })
  const [isLoading, setIsLoading] = useState(false)

  function handleChange(e) {
    const { name, value } = e.target
    setFields((f) => ({ ...f, [name]: value }))
  }

  function handleKeyDown(e) {
    if (
      e.key === 'Enter' &&
      (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA')
    ) {
      if (e.target.name !== 'title_hebrew') e.preventDefault()
    }
  }

async function handleSubmit(e) {
  e.preventDefault()
  if (
    !window.confirm(
      "אנא ודא/י שכל הפרטים נכונים ומתורגמים לעברית.\n\nהאם לשלוח את הצעת העריכה?"
    )
  ) {
    return
  }
  setIsLoading(true)
  try {
    const newData = {
      ...fields,
      mal_id: anime.mal_id,
      anizone_id: anime.anizone_id,
    }
    await suggestAnimeEdit(anime.mal_id || anime.anizone_id, newData)
    toast.success('הצעת העריכה נשלחה! היא תיבדק על ידי אדמין.')
    if (onClose) onClose()
  } catch (err) {
    toast.error('אירעה שגיאה בשליחת ההצעה')
  } finally {
    setIsLoading(false)
  }
}

  function isChanged(fieldKey, origValue, newValue) {
    return (
      newValue &&
      newValue.trim() !== '' &&
      newValue.trim() !== (origValue || '').trim()
    )
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="p-6 bg-neutral-900 rounded-2xl max-w-3xl mx-auto mt-8 shadow-lg border border-neutral-800"
      onKeyDown={handleKeyDown}
      autoComplete="off"
      dir="rtl"
    >
      {/* הודעת פתיחה */}
      <div className="mb-6 p-4 bg-yellow-200/10 border-l-4 border-yellow-400 rounded-lg text-yellow-200 text-right shadow">
        <span className="font-bold text-lg text-yellow-100 block mb-1">
          תרמו ושפרו את האתר!
        </span>
        <span className="text-sm text-yellow-100/90 block mb-2">
          כל אחד ואחת יכולים להציע תיקונים או עדכונים למידע על אנימות באתר. כל
          תרומה עוזרת לנו לשפר את הקהילה האנימית בישראל ולבנות מאגר מידע איכותי
          ועדכני יותר לכולנו. תודה ענקית על הזמן והעזרה שלכם!
        </span>
        <span className="text-xs text-yellow-300 block mt-2">
          <span className="font-bold text-yellow-400 pr-1">אזהרה:</span>
          הגשת מידע שגוי במכוון, טרולים או ניסיונות להרוס את האתר – יגררו חסימה
          קבועה מהמערכת וללא אזהרה נוספת.
        </span>
      </div>

      <h2 className="text-2xl font-bold mb-8 text-center text-white tracking-tight">
        עריכת מידע לאנימה
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {/* שם באנגלית */}
        <div>
          <label className="font-semibold text-sm text-gray-300 mb-1 block">
            שם באנגלית
          </label>
          <div className="w-full bg-neutral-800 text-white min-h-[40px] flex items-center px-3 rounded-xl border border-neutral-700">
            {anime.title || <span className="text-neutral-500">—</span>}
          </div>
        </div>
        {/* שם בעברית */}
        <div>
          <label className="font-semibold text-sm text-gray-300 mb-1 block">
            שם בעברית
          </label>
          <input
            className={`w-full bg-neutral-800 text-white rounded-xl border border-neutral-700 focus:ring-2 focus:ring-primary-400 transition min-h-[40px] px-3 py-2 text-base placeholder:text-gray-400 ${
              isChanged('title_hebrew', anime.title_hebrew, fields.title_hebrew)
                ? 'bg-green-900/60'
                : ''
            }`}
            name="title_hebrew"
            value={fields.title_hebrew}
            onChange={handleChange}
            autoComplete="off"
            dir="rtl"
            maxLength={80}
            placeholder="לדוג' וואן פיס"
          />
        </div>

        {/* תקציר (אנגלית) */}
        <div>
          <label className="font-semibold text-sm text-gray-300 mb-1 block">
            תקציר (אנגלית)
          </label>
          <div className="w-full bg-neutral-800 text-white min-h-[90px] px-3 py-2 overflow-y-auto whitespace-pre-line text-sm rounded-xl border border-neutral-700">
            {anime.synopsis || <span className="text-neutral-500">—</span>}
          </div>
        </div>
        {/* תקציר (עברית) */}
        <div>
          <label className="font-semibold text-sm text-gray-300 mb-1 block">
            תקציר (עברית)
          </label>
          <textarea
            className={`w-full bg-neutral-800 text-white rounded-xl border border-neutral-700 focus:ring-2 focus:ring-primary-400 transition min-h-[220px] h-[220px] resize-y p-4 text-base md:text-lg placeholder:text-gray-400 ${
              isChanged(
                'synopsis_hebrew',
                anime.synopsis_hebrew,
                fields.synopsis_hebrew
              )
                ? 'bg-green-900/60'
                : ''
            }`}
            name="synopsis_hebrew"
            value={fields.synopsis_hebrew}
            onChange={handleChange}
            dir="rtl"
            placeholder="כתבו תקציר מתורגם/מעובד בעברית"
            maxLength={3000}
          />
        </div>

        {/* רקע (אנגלית) */}
        <div>
          <label className="font-semibold text-sm text-gray-300 mb-1 block">
            רקע (אנגלית)
          </label>
          <div className="w-full bg-neutral-800 text-white min-h-[90px] px-3 py-2 overflow-y-auto whitespace-pre-line text-sm rounded-xl border border-neutral-700">
            {anime.background || <span className="text-neutral-500">—</span>}
          </div>
        </div>
        {/* רקע (עברית) */}
        <div>
          <label className="font-semibold text-sm text-gray-300 mb-1 block">
            רקע (עברית)
          </label>
          <textarea
            className={`w-full bg-neutral-800 text-white rounded-xl border border-neutral-700 focus:ring-2 focus:ring-primary-400 transition min-h-[220px] h-[220px] resize-y p-4 text-base md:text-lg placeholder:text-gray-400 ${
              isChanged(
                'background_hebrew',
                anime.background_hebrew,
                fields.background_hebrew
              )
                ? 'bg-green-900/60'
                : ''
            }`}
            name="background_hebrew"
            value={fields.background_hebrew}
            onChange={handleChange}
            dir="rtl"
            placeholder="כתבו רקע מעודכן בעברית"
            maxLength={2500}
          />
        </div>
      </div>

      

      <div className="flex gap-3 mt-10">
        <button
          type="submit"
          disabled={isLoading}
          className="flex-1 text-lg font-bold py-3 rounded-xl transition bg-primary shadow-xl"
        >
          {isLoading ? 'שולח...' : 'שלח הצעת עריכה'}
        </button>
        {onClose && (
          <button
            type="button"
            className="flex-1 text-lg font-bold py-3 rounded-xl border border-neutral-700 hover:bg-neutral-800 shadow"
            onClick={onClose}
          >
            ביטול
          </button>
        )}
      </div>
    </form>
  )
}
